(() => {
  const root = document.getElementById('atlas-refined-offer');
  if (!root || typeof root.showModal !== 'function') return;
  const form = root.querySelector('form');
  const signup = root.querySelector('[data-signup]');
  const success = root.querySelector('[data-success]');
  const key = 'atlas-welcome-dismissed-until';
  const pendingKey = 'atlas-welcome-pending';
  let oldOverflow = '';
  let previousFocus;
  const read = (storage, name) => { try { return storage.getItem(name); } catch (_) { return null; } };
  const write = (storage, name, value) => { try { storage.setItem(name, value); } catch (_) {} };
  const dismiss = () => {
    write(localStorage, key, String(Math.max(Number(read(localStorage, key)) || 0, Date.now() + 7 * 86400000)));
    root.close();
  };
  const open = () => {
    previousFocus = document.activeElement;
    oldOverflow = document.documentElement.style.overflow;
    root.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  root.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus({preventScroll:true});
  });
  root.addEventListener('cancel', e => { e.preventDefault(); dismiss(); });
  root.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', dismiss));
  root.addEventListener('click', e => { if (e.target === root) { const r=root.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dismiss(); } });
  form.addEventListener('submit', () => {
    write(sessionStorage, pendingKey, String(Date.now()));
  });
  root.querySelector('[data-copy]').addEventListener('click', async e => {
    const button = e.currentTarget;
    try { await navigator.clipboard.writeText('ATLAS10'); button.textContent = root.dataset.copied; }
    catch (_) {
      const range = document.createRange(); range.selectNodeContents(root.querySelector('[data-code]'));
      const selection=window.getSelection(); selection.removeAllRanges(); selection.addRange(range);
      root.querySelector('[data-copy]').textContent=root.dataset.selected;
    }
  });
  const pending = Number(read(sessionStorage, pendingKey));
  const ownReturn = location.hash === '#AtlasWelcomeForm' || (pending > 0 && Date.now() - pending < 1800000);
  if (ownReturn && root.querySelector('[data-posted]')) {
    signup.hidden = true; success.hidden = false;
    write(sessionStorage, pendingKey, '0');
    write(localStorage, key, String(Date.now() + 365 * 86400000));
    open();
    return;
  }
  if (ownReturn && root.querySelector('[data-errors]')) { open(); return; }
  if (Number(read(localStorage, key)) > Date.now()) return;
  setTimeout(open, Math.max(0, 8000 - performance.now()));
})();
